import React from 'react'
import { Text } from 'src/viewLayer/components/DesignSystem'

import { InterpolatedLink } from './index.styled'

const InterpolateLink = ({ firstLink, secondLink, translation }) => {
  const firstSplitter = `%{${firstLink.name}}`
  const secondSplitter = `%{${secondLink.name}}`

  const [part1, rest] = translation.split(firstSplitter)
  const [part2, part3] = rest.split(secondSplitter)

  return (
    <Text fontSize={{ small: 'small' }}>
      <span>{part1}</span>
      <InterpolatedLink
        href={firstLink.path}
        size={'small'}
        target="_blank"
        underlined={false}
        weight="strong"
      >
        {firstLink.translation}
      </InterpolatedLink>
      <span>{part2}</span>
      <InterpolatedLink
        href={secondLink.path}
        size={'small'}
        target="_blank"
        underlined={false}
        weight="strong"
      >
        {secondLink.translation}
      </InterpolatedLink>
      <span>{part3}</span>
    </Text>
  )
}

export default InterpolateLink
